/*!
 * Extended JavaScript Loader & Image Cacher
 *
 * @requires jQuery v1.8.0 or newer
 *
 * @author Ivan Azaryonok (http://mesos.ru) & Grigory Zarubin (http://craigy.ru)
 * @version 1.0.2
 * @date 08.11.2012
 *
 * Dual licensed under the MIT or GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 */

/*
 * Асинхронно подгружает внешние яваскрипты:
 * $.loadScript(
 *   url                                   // урл
 *                                         // ИЛИ
 *   ['url1', 'url2', 'url3'],             // массив урлов скриптов
 *   {
 *     charset    : 'windows-1251',        // кодировка скрипта (используется при несовпадении с основной кодировкой страницы)
 *     modify     : {                      // готовые модификаторы (можно активировать как один, так и некий набор)
 *
 *       content  : '#container',          // блокирует все кривые методы document.open/close/write/writeln и самостоятельно выводит результат работы скрипта
 *                                            (значением параметра должен быть jquery-селектор, возвращающий элемент, в который будет происходить вывод)
 *                                            ВНИМАНИЕ! Обязательно включайте этот модификатор, если в подгружаемом скрипте используются указанные выше методы!
 *       seo  : '#container'               // делает тоже самое, что и модификатор 'content', при этом выводя все ссылки с атрибутом rel="nofollow"
 *
 *     },
 *     onComplete :                        // коллбэк-функция или массив функций, вызываемых после успешной загрузки ВСЕХ скриптов
 *       function(data, status, jqXHR),
 *     onError    :                        // коллбэк-функция или массив функций, вызываемых после попыток загрузки ВСЕХ скриптов в случае какой-либо ошибки
 *       function(jqXHR, status, error)
 *   }
 * );
 *
 * Кэширует картинки:
 * $.cacheImage(
 *   url                                   // урл
 *                                         // ИЛИ
 *   ['url1', 'url2', 'url3'],             // массив урлов картинок
 *   {
 *     onComplete :                        // коллбэк-функция или массив функций, вызываемых после успешной загрузки ВСЕХ картинок
 *       function(data, status, jqXHR),
 *     onError    :                        // коллбэк-функция или массив функций, вызываемых после попыток загрузки ВСЕХ картинок в случае, если хотя бы одна картинка не загрузилась
 *       function(jqXHR, status, error)
 *   }
 * );
 */

(function($) {
  // Общий подгрузчик
  $.loadData = function(url, opts, onComplete, onError) {
    var urls = [];
    if($.type(url)==='string') urls.push(url); else urls = url;

    if(!urls.length) {
      if($.type(onError)==='function') onError({}, 'error', 'no items to load');
      return;
    }

    // Функция, создающая нужное число асинхронных запросов
    var getData = function() {
      var requests = [];
      for(var i=0,l=urls.length; i<l; i++) requests.push($.ajax($.extend({}, {url: urls[i]}, opts)));
      return requests;
    };

    $.when.apply(null, getData()).then(function() { // все коллбэки вызываются только после получения ВСЕХ ответов
      $.each(onComplete, $.proxy(function(key, value) {
        value.call(this);
      }, this));
    }, function() {
      $.each(onError, $.proxy(function(key, value) {
        value.call(this);
      }, this));
    });
  };



  // Асинхронно подгружает внешние яваскрипты
  $.loadScript = function(url, options) {
    if(!url) return;
    var opts = $.extend(true, {}, $.loadScript.defaults, options);

    var modify = $.loadScript.modify(url, opts); // создаем обработчик модификаторов
    for(var i in opts.modify) modify.prepare(i); // модификаторы: подготовка перед запросом

    var completes = [], errors = [];
    completes.push(function() {
      for(var i in opts.modify) modify.process(i); // модификаторы: непосредственно сам процесс)
    });
    errors.push(function() {
      for(var i in opts.modify) modify.fallback(i); // модификаторы: отмена действий при ошибке загрузки
    });
    if($.isArray(opts.onComplete)) $.merge(completes, opts.onComplete); else completes.push(opts.onComplete);
    if($.isArray(opts.onError)) $.merge(errors, opts.onError); else errors.push(opts.onError);

    $.loadData(url, { dataType : 'script', scriptCharset : opts.charset, cache: opts.cache }, completes, errors);
    return $;
  };

  // Обёртка для запуска модификаторов
  $.loadScript.modify = function(url, opts) {
    var context = {}, // эта переменная будет уникальна и замкнута на все методы возвращаемого объекта
        modify = {    // вынес в отдельную переменную, чтобы запускать cleanup из других методов
          // Подготовка
          prepare: function(i) {
            var val = opts.modify[i];
            switch(i) {
              case 'content': case 'seo':
                context.stack = [];
                context.runtime = {};
                // Пусть лучше будут все в отдельном месте
                $.each(['write', 'writeln', 'open', 'close'], function(index, value) {
                  context.runtime[value] = document[value];
                });
                document.write = function() {
                  // Аргументов может быть несколько: http://www.w3schools.com/jsref/met_doc_write.asp
                  context.stack.push([].slice.call(arguments).join(''));
                };
                document.writeln = function() {
                  // Перенос на всякий случай будем добавлять, чтобы по стандарту было: http://www.w3schools.com/jsref/met_doc_writeln.asp
                  context.stack.push([].slice.call(arguments).join('')+'\r\n');
                };
                document.open = $.noop;
                document.close = $.noop;
              break;
            }
          },
          // Отмена
          fallback: function(i) {
            var val = opts.modify[i];
            switch(i) {
              case 'content': case 'seo':
              break;
            }
            modify.cleanup(i);
          },
          // Отработка
          process: function(i) {
            var val = opts.modify[i];
            switch(i) {
              case 'content':
                $(val).html(context.stack.join(''));
              break;

              case 'seo':
                $(val).html(context.stack.join('')).find('a').attr('rel', 'nofollow');
              break;
            }
            modify.cleanup(i);
          },
          // Сброс возможных перехватчиков (вынес сюда, дабы избежать дублирования кода в трёх местах выше)
          cleanup: function(i) {
            switch(i) {
              case 'content': case 'seo':
                if('runtime' in context) {
                  $.each(context.runtime, function(index, value) {
                    document[index] = value;
                  });
                }
              break;
            }
          }
        };
    return modify;
  };

  $.loadScript.defaults = {
    cache      : false,
    charset    : 'utf-8',
    modify     : {},
    onComplete : $.noop,
    onError    : $.noop
  };



  // Кэширует картинки
  $.cacheImage = function(url, options) {
    if(!url) return;
    var opts = $.extend({}, $.cacheImage.defaults, options);

    var completes = [], errors = [];
    if(!$.isArray(opts.onComplete)) completes.push(opts.onComplete); else completes = opts.onComplete;
    if(!$.isArray(opts.onError)) errors.push(opts.onError); else errors = opts.onError;

    $.loadData(url, { dataType : 'image' }, completes, errors);
    return $;
  };

  // Простенький транспорт для подгрузки картинок
  jQuery.ajaxTransport('image', function(s) {
    if(s.type === 'GET' && s.async) {
      var image;
      return {
        send: function(_, callback) {
          image = new Image();

          function done(status) {
            if(image) {
              var textStatus = (status == 200) ? 'success' : 'image not found',
              tmp = image;
              image = image.onreadystatechange = image.onerror = image.onload = null;
              callback(status, textStatus, { image : tmp });
            }
          }

          image.onreadystatechange = image.onload = function() {
            done(200);
          };
          image.onerror = function() {
            done(404);
          };

          image.src = s.url;
        },

        abort: function() {
          if(image) {
            image = image.onreadystatechange = image.onerror = image.onload = null;
          }
        }
      };
    }
  });

  $.cacheImage.defaults = {
    onComplete : $.noop,
    onError    : $.noop
  };
})(jQuery);